module.exports = __webpack_public_path__ + "media/svg-new/icon-gray-maxia-a6583cd2.svg";